// src/BodyPartsInfo.js

import React, { useState } from 'react';
import './BodyPartsInfo.css';

const bodyPartsData = {
    "Heart": {
      uses: "Pumps blood throughout the body.",
      importance: "Essential for circulating oxygen and nutrients.",
      helps: "Maintains blood flow and pressure.",
      image: "https://example.com/heart.jpg",
      otherSpecialities: [
        "Beats approximately 100,000 times a day.",
        "Has its own electrical system.",
        "Can continue beating even when disconnected from the body."
      ]
    },
    "Brain": {
      uses: "Controls thoughts, memory, and bodily functions.",
      importance: "Central organ of the nervous system.",
      helps: "Regulates all bodily functions and processes.",
      image: "https://example.com/brain.jpg",
      otherSpecialities: [
        "Contains approximately 86 billion neurons.",
        "Responsible for cognitive functions.",
        "Protected by the skull and cerebrospinal fluid."
      ]
    },
    "Lungs": {
      uses: "Facilitates gas exchange (oxygen and carbon dioxide).",
      importance: "Essential for respiration.",
      helps: "Provides oxygen to the bloodstream and removes carbon dioxide.",
      image: "https://example.com/lungs.jpg",
      otherSpecialities: [
        "Contains approximately 300 million alveoli.",
        "Can hold up to 6 liters of air.",
        "Works in conjunction with the diaphragm."
      ]
    },
    "Liver": {
      uses: "Detoxifies chemicals and metabolizes drugs.",
      importance: "Vital for detoxification and metabolism.",
      helps: "Produces bile to aid in digestion.",
      image: "https://example.com/liver.jpg",
      otherSpecialities: [
        "Regenerates if damaged.",
        "Stores vitamins and minerals.",
        "Processes nutrients absorbed from the digestive tract."
      ]
    },
    "Kidneys": {
      uses: "Filters blood to produce urine.",
      importance: "Essential for removing waste and excess substances.",
      helps: "Maintains fluid and electrolyte balance.",
      image: "https://example.com/kidneys.jpg",
      otherSpecialities: [
        "Produces hormones for blood pressure regulation.",
        "Regulates acid-base balance.",
        "Removes toxins from the body."
      ]
    },
    "Stomach": {
      uses: "Breaks down food through digestion.",
      importance: "Initial stage of digestion.",
      helps: "Secretes digestive acids and enzymes.",
      image: "https://example.com/stomach.jpg",
      otherSpecialities: [
        "Muscular walls churn food.",
        "Absorbs some nutrients.",
        "Produces intrinsic factor for vitamin B12 absorption."
      ]
    },
    "Intestines": {
      uses: "Absorbs nutrients from digested food.",
      importance: "Critical for nutrient absorption.",
      helps: "Facilitates digestion and waste elimination.",
      image: "https://example.com/intestines.jpg",
      otherSpecialities: [
        "Small intestine absorbs nutrients.",
        "Large intestine absorbs water and electrolytes.",
        "Hosts beneficial gut bacteria."
      ]
    },
    "Skin": {
      uses: "Protects the body from external harm.",
      importance: "Acts as a barrier against pathogens.",
      helps: "Regulates body temperature and sensation.",
      image: "https://example.com/skin.jpg",
      otherSpecialities: [
        "Largest organ of the body.",
        "Produces vitamin D when exposed to sunlight.",
        "Contains various sensory receptors."
      ]
    },
    "Eyes": {
      uses: "Provides vision.",
      importance: "Essential for perceiving the environment.",
      helps: "Processes light to create images.",
      image: "https://example.com/eyes.jpg",
      otherSpecialities: [
        "Contains rod and cone cells for light detection.",
        "Connected to the brain via the optic nerve.",
        "Can detect a wide range of colors and intensities."
      ]
    },
    "Ears": {
      uses: "Enables hearing and balance.",
      importance: "Critical for communication and spatial orientation.",
      helps: "Converts sound waves into nerve signals.",
      image: "https://example.com/ears.jpg",
      otherSpecialities: [
        "Contains tiny bones (ossicles) for sound amplification.",
        "Inner ear helps maintain balance.",
        "Sensitive to a wide range of frequencies."
      ]
    },
    "Mouth": {
      uses: "Starts the digestion process.",
      importance: "Initial stage of mechanical and chemical digestion.",
      helps: "Chews food and mixes it with saliva.",
      image: "https://example.com/mouth.jpg",
      otherSpecialities: [
        "Contains teeth and tongue for chewing and swallowing.",
        "Saliva contains enzymes for breaking down food.",
        "Plays a role in speech and taste."
      ]
    },
    "Teeth": {
      uses: "Chews food for digestion.",
      importance: "Essential for mechanical digestion.",
      helps: "Breaks down food into smaller pieces.",
      image: "https://example.com/teeth.jpg",
      otherSpecialities: [
        "Different types (incisors, canines, molars) for various functions.",
        "Protected by enamel.",
        "Anchored in the jawbone by roots."
      ]
    },
    "Tongue": {
      uses: "Assists in chewing, swallowing, and speech.",
      importance: "Critical for taste and communication.",
      helps: "Mixes food with saliva.",
      image: "https://example.com/tongue.jpg",
      otherSpecialities: [
        "Contains taste buds for detecting flavors.",
        "Helps in forming speech sounds.",
        "Flexible and muscular for various movements."
      ]
    },
    "Nose": {
      uses: "Facilitates breathing and sense of smell.",
      importance: "Critical for respiration and olfaction.",
      helps: "Filters and humidifies air.",
      image: "https://example.com/nose.jpg",
      otherSpecialities: [
        "Contains olfactory receptors for smell detection.",
        "Plays a role in taste.",
        "Acts as a primary passageway for air."
      ]
    },
    "Hands": {
      uses: "Enables grasping and manipulation.",
      importance: "Essential for daily tasks and fine motor skills.",
      helps: "Performs precise movements.",
      image: "https://example.com/hands.jpg",
      otherSpecialities: [
        "Contains numerous bones, muscles, and tendons.",
        "Highly sensitive to touch.",
        "Capable of a wide range of motions."
      ]
    },
    "Feet": {
      uses: "Supports body weight and enables locomotion.",
      importance: "Critical for balance and movement.",
      helps: "Facilitates walking, running, and standing.",
      image: "https://example.com/feet.jpg",
      otherSpecialities: [
        "Contains arches for shock absorption.",
        "Has a complex structure of bones and ligaments.",
        "Plays a role in maintaining posture."
      ]
    },
    "Spine": {
      uses: "Supports the body and protects the spinal cord.",
      importance: "Critical for posture and movement.",
      helps: "Allows for flexibility and mobility.",
      image: "https://example.com/spine.jpg",
      otherSpecialities: [
        "Consists of 33 vertebrae.",
        "Acts as a shock absorber for the body.",
        "Provides attachment points for muscles."
      ]
    },
    "Muscles": {
      uses: "Facilitates movement and maintains posture.",
      importance: "Essential for body mobility and strength.",
      helps: "Contracts and relaxes to produce motion.",
      image: "https://example.com/muscles.jpg",
      otherSpecialities: [
        "Three types: skeletal, smooth, and cardiac.",
        "Skeletal muscles are under voluntary control.",
        "Can grow and strengthen with exercise."
      ]
    },
    "Bones": {
      uses: "Provides structure and protection.",
      importance: "Essential for body shape and organ protection.",
      helps: "Supports and anchors muscles.",
      image: "https://example.com/bones.jpg",
      otherSpecialities: [
        "Contains bone marrow for blood cell production.",
        "Stores minerals like calcium and phosphorus.",
        "Connected by joints for movement."
      ]
    },
    "Skin": {
      uses: "Protects the body from external harm.",
      importance: "Acts as a barrier against pathogens.",
      helps: "Regulates body temperature and sensation.",
      image: "https://example.com/skin.jpg",
      otherSpecialities: [
        "Largest organ of the body.",
        "Produces vitamin D when exposed to sunlight.",
        "Contains various sensory receptors."
      ]
    },
  };
  

const BodyPartsInfo = () => {
  const [selectedBodyPart, setSelectedBodyPart] = useState('Heart');
  const [readAloud, setReadAloud] = useState(false);

  const handleBodyPartChange = (e) => {
    setSelectedBodyPart(e.target.value);
  };

  const handleReadAloud = () => {
    const bodyPart = bodyPartsData[selectedBodyPart];
    const utterance = new SpeechSynthesisUtterance(
      `The ${selectedBodyPart} is used for ${bodyPart.uses}. It is important because ${bodyPart.importance}. It helps the body by ${bodyPart.helps}. Other specialities include ${bodyPart.otherSpecialities.join(", ")}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  const bodyPart = bodyPartsData[selectedBodyPart];

  return (
    <div className="body-parts-info">
      <h1>Body Parts Information</h1>
      <div>
        <label>
          Select Body Part:
          <select value={selectedBodyPart} onChange={handleBodyPartChange}>
            {Object.keys(bodyPartsData).map((bodyPart) => (
              <option key={bodyPart} value={bodyPart}>{bodyPart}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedBodyPart}</h2>
        <p><strong>Uses:</strong> {bodyPart.uses}</p>
        <p><strong>Importance:</strong> {bodyPart.importance}</p>
        <p><strong>How it helps the body:</strong> {bodyPart.helps}</p>
        <img src={bodyPart.image} alt={selectedBodyPart} />
        <p><strong>Other Specialities:</strong></p>
        <ul>
          {bodyPart.otherSpecialities.map((speciality, index) => (
            <li key={index}>{speciality}</li>
          ))}
        </ul>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default BodyPartsInfo;
